module.exports = __webpack_public_path__ + "static/media/phone_scroll_3.3f9b6053.png";